import {
    LayoutBottomPaneState,
    LayoutSidebarState,
    LayoutTopPaneState,
} from '../Types/layoutTypes'
import {
    LayoutTopPaneType,
    LayoutPaneSubtype,
    LayoutSidebarPaneType,
    LayoutBottomPaneType,
} from '../Panes/types-and-constants/LayoutPaneTypesAndConstants'
import { RetainBehaviorModifier } from '../../../atoms/Retain/constants/modifiers'
import { LayoutContextProps } from '../../../../providers'

const getSidebarRetainBehavior = (sidebarState?: LayoutSidebarState): RetainBehaviorModifier => {
    switch (sidebarState?.paneType) {
        case LayoutSidebarPaneType.SIDEBAR_STICKY_LEFT:
            return RetainBehaviorModifier.PADDING_INLINE_START
        case LayoutSidebarPaneType.SIDEBAR_STICKY_RIGHT:
            return RetainBehaviorModifier.PADDING_INLINE_END
        default:
            return RetainBehaviorModifier.PADDING
    }
}

const getContentRetainBehavior = (sidebarState?: LayoutSidebarState): RetainBehaviorModifier => {
    switch (sidebarState?.paneType) {
        case LayoutSidebarPaneType.SIDEBAR_STICKY_LEFT:
            return RetainBehaviorModifier.PADDING_INLINE_END
        case LayoutSidebarPaneType.SIDEBAR_STICKY_RIGHT:
            return RetainBehaviorModifier.PADDING_INLINE_START
        default:
            return RetainBehaviorModifier.PADDING
    }
}
const getTopAndBottomPaneRetainBehavior = (
    paneState: LayoutTopPaneState | LayoutBottomPaneState,
    sidebarState?: LayoutSidebarState,
): RetainBehaviorModifier => {
    switch (paneState.paneType) {
        case LayoutTopPaneType.TOP_PANE_STICKY:
        case LayoutTopPaneType.TOP_PANE_INLINE:
        case LayoutBottomPaneType.BOTTOM_PANE_STICKY:
        case LayoutBottomPaneType.BOTTOM_PANE_INLINE:
            return getContentRetainBehavior(sidebarState)
        default:
            return RetainBehaviorModifier.PADDING
    }
}

export const getRetainBehaviorModifierForPane = (
    paneType: LayoutPaneSubtype,
    layoutContext?: LayoutContextProps,
): RetainBehaviorModifier => {
    const category = paneType.toLowerCase().replace(/.*(top-pane|sidebar|content|bottom-pane).*/, '$1')
    switch (category) {
        case 'sidebar':
            return getSidebarRetainBehavior(layoutContext?.sidebarState)
        case 'content':
            return getContentRetainBehavior(layoutContext?.sidebarState)
        case 'top-pane':
            return getTopAndBottomPaneRetainBehavior(
                layoutContext?.topPaneState || ({ paneType } as LayoutTopPaneState),
                layoutContext?.sidebarState,
            )
        case 'bottom-pane':
            return getTopAndBottomPaneRetainBehavior(
                layoutContext?.bottomPaneState || ({ paneType } as LayoutBottomPaneState),
                layoutContext?.sidebarState,
            )
        default:
            return RetainBehaviorModifier.PADDING
    }
}
